import * as type from './mutation-types'
import * as API from './api'
import { ajax } from '@/utils/fetch'

// 用户信息
export const thirdPayLogin = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.THIRDPAYLOGIN_REQUEST, data)
        // http 请求
    return ajax.upload(
        API.thirdPayLogin, {
            commit
        },
        data,
        type.THIRDPAYLOGIN_RECEIVE
    )
};

// 直接登录
export const thirdPayDrLogin = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.THIRDPAYDRLOGIN_REQUEST, data)
        // http 请求
    return ajax.postPay(
        API.thirdPayDrLogin, {
            commit
        },
        data,
        type.THIRDPAYDRLOGIN_RECEIVE
    )
};

// 币种和档位映射关系
export const getCurrencyGear = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETCURRENCYGEAR_REQUEST, data)
        // http 请求
    return ajax.getPay(
        API.getCurrencyGear, {
            commit
        },
        data,
        type.GETCURRENCYGEAR_RECEIVE
    )
};

// 支付方式列表获取
export const getAllPayMode = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETALLPAYMODE_REQUEST, data)
        // http 请求
    return ajax.getPay(
        API.getAllPayMode, {
            commit
        },
        data,
        type.GETALLPAYMODE_RECEIVE
    )
};

// 三方支付商品列表获取
export const serverIapList = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.SERVERIAPLIST_REQUEST, data)
        // http 请求
    return ajax.get(
        API.serverIapList, {
            commit
        },
        data,
        type.SERVERIAPLIST_RECEIVE
    )
};

// 三方支付消费记录
export const getThirdPayOrderList = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETTHIRDPAYORDERLIST_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getThirdPayOrderList, {
            commit
        },
        data,
        type.GETTHIRDPAYORDERLIST_RECEIVE
    )
};

// 创建三方支付订单
export const createThirdPayOrder = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.CREATETHIRDPAYORDER_REQUEST, data)
        // http 请求
    return ajax.postPay(
        API.createThirdPayOrder, {
            commit
        },
        data,
        type.CREATETHIRDPAYORDER_RECEIVE
    )
};

// 三方订单校验
export const verifyThirdPayOrder = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.VERIFYTHIRDPAYORDER_REQUEST, data)
        // http 请求
    return ajax.post(
        API.verifyThirdPayOrder, {
            commit
        },
        data,
        type.VERIFYTHIRDPAYORDER_RECEIVE
    )
};

// 执行请款
export const thirdPayOrderRequestPay = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.THIRDPAYORDERREQUESTPAY_REQUEST, data)
        // http 请求
    return ajax.post(
        API.thirdPayOrderRequestPay, {
            commit
        },
        data,
        type.THIRDPAYORDERREQUESTPAY_RECEIVE
    )
};

// 查询商品详情
export const getThirdPayGoodsDetail = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETTHIRDPAYGOODSDETAIL_REQUEST, data)
        // http 请求
    return ajax.postPay(
        API.getThirdPayGoodsDetail, {
            commit
        },
        data,
        type.GETTHIRDPAYGOODSDETAIL_RECEIVE
    )
};

// 获取游戏角色上一次支付成功的支付方式
export const getDefaultPayment = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETDEFAULTPAYMENT_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getDefaultPayment, {
            commit
        },
        data,
        type.GETDEFAULTPAYMENT_RECEIVE
    )
};

// 基于 token 列表检验合法角色 token
export const checkRolesToken = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.CHECKROLESTOKEN_REQUEST, data)
        // http 请求
    return ajax.post(
        API.checkRolesToken, {
            commit
        },
        data,
        type.CHECKROLESTOKEN_RECEIVE
    )
};

// 三方支付查询子订单
export const orderSublist = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.ORDERSUBLIST_REQUEST, data)
        // http 请求
    return ajax.get(
        API.orderSublist, {
            commit
        },
        data,
        type.ORDERSUBLIST_RECEIVE
    )
};

// 三方商城获取用户 礼金 剩余数
export const getUserPointData = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETUSERPOINTDATA_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getUserPointData, {
            commit
        },
        data,
        type.GETUSERPOINTDATA_RECEIVE
    )
};

// 三方商城获取 礼金 使用规则说明
export const getUserPointRule = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETUSERPOINTRULE_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getUserPointRule, {
            commit
        },
        data,
        type.GETUSERPOINTRULE_RECEIVE
    )
};

// 三方商城获取 礼金 使用规则开关
export const getUserPointSwitch = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETUSERPOINTSWITCH_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getUserPointSwitch, {
            commit
        },
        data,
        type.GETUSERPOINTSWITCH_RECEIVE
    )
};

// 三方商城获取邮箱验证码
export const getEmailCode = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETEMAILCODE_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getEmailCode, {
            commit
        },
        data,
        type.GETEMAILCODE_RECEIVE
    )
};

// 三方商城设置三方支付安全邮箱
export const setPayEmail = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.SETPAYEMAIL_REQUEST, data)
        // http 请求
    return ajax.post(
        API.setPayEmail, {
            commit
        },
        data,
        type.SETPAYEMAIL_RECEIVE
    )
};

// 三方商城校验用户是否为首次支付
export const getPointInit = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETPOINTINIT_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getPointInit, {
            commit
        },
        data,
        type.GETPOINTINIT_RECEIVE
    )
};

// 三方商城校验用户是否已经设置支付密码
export const getPayPwdFlag = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETPAYPWDFLAG_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getPayPwdFlag, {
            commit
        },
        data,
        type.GETPAYPWDFLAG_RECEIVE
    )
};

// 三方商城校验用户是否设置安全邮箱
export const getEmailFlag = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETEMAILFLAG_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getEmailFlag, {
            commit
        },
        data,
        type.GETEMAILFLAG_RECEIVE
    )
};

// 三方商城设置三方支付支付密码
export const setPayPwd = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.SETPAYPWD_REQUEST, data)
        // http 请求
    return ajax.post(
        API.setPayPwd, {
            commit
        },
        data,
        type.SETPAYPWD_RECEIVE
    )
};

// 三方商城修改三方支付支付密码
export const changePayPwd = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.CHANGEPAYPWD_REQUEST, data)
        // http 请求
    return ajax.postPay(
        API.changePayPwd, {
            commit
        },
        data,
        type.CHANGEPAYPWD_RECEIVE
    )
};

// 查询三方支付安全邮箱地址
export const getUserPayEmail = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETUSERPAYEMAIL_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getUserPayEmail, {
            commit
        },
        data,
        type.GETUSERPAYEMAIL_RECEIVE
    )
};

// 三方商城修改密码时校验支付旧密码
export const checkPayPwd = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.CHECKPAYPWD_REQUEST, data)
        // http 请求
    return ajax.getPay(
        API.checkPayPwd, {
            commit
        },
        data,
        type.CHECKPAYPWD_RECEIVE
    )
};

// 三方商城修改密码时校验支付旧密码
export const checkPayEmail = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.CHECKPAYEMAIL_REQUEST, data)
        // http 请求
    return ajax.getPay(
        API.checkPayEmail, {
            commit
        },
        data,
        type.CHECKPAYEMAIL_RECEIVE
    )
};

// 三方商城修改密码时校验支付旧密码
export const checkUPay = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.CHECKUPAY_REQUEST, data)
        // http 请求
    return ajax.upload(
        API.checkUPay, {
            commit
        },
        data,
        type.CHECKUPAY_RECEIVE
    )
};

//版本号查询
export const getVersion = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETVERSION_REQUEST, data)
        // http 请求
    return ajax.get(
        API.getVersion, {
            commit
        },
        data,
        type.GETVERSION_RECEIVE
    )
};
// center 模块 ParamTrackerCtrl 
export const trackLog = ({ commit }, data) => {
    commit(type.TRACKLOG_REQUEST, data);
    return ajax.post(
        API.trackLog,
        { commit },
        data,
        type.TRACKLOG_RECEIVE
    );
};